import React, { useState } from "react";

import SpringBootRequests from "./SprinBootRequest";
import SpringBootIntro from "./SpringBootIntro";
import SpringBootSetup from "./SpringBootSetup";
import SpringBootDIBeans from "./SpringBootDIBeans";
import SpringBootAnnotations from "./SpringBootAnnotations";
import SpringBootRestControllers from "./SpringBootRestControllers";
import SpringBootValidation from "./SpringBootValidation";
import SpringBootServiceLayer from "./SpringBootServiceLayer";
import SpringBootJpaRepo from "./SpringBootJpaRepo";
import SpringBootRelationships from "./SpringBootRelationships";
import SpringBootPagination from "./SpringBootPagination";
import SpringBootDTO from "./SpringBootDTO";
import SpringBootSecurity from "./SpringBootSecurity";
import SpringBootJWT from "./SpringBootJWT";
import SpringBootRoles from "./SpringBootRoles";
import SpringBootGlobalError from "./SpringBootGlobalError";
import SpringBootTesting from "./SpringBootTesting";
import SpringBootSwagger from "./SpringBootSwagger";
import SpringBootDeployment from "./SpringBootDeployment";

const tabs = [
    { label: "Introduction to Spring & Spring Boot", component: <SpringBootIntro /> },
    { label: "Project Structure & Setup", component: <SpringBootSetup /> },
    { label: "DI & Beans", component: <SpringBootDIBeans /> },
    { label: "Annotations", component: <SpringBootAnnotations /> },
    { label: "REST Controllers", component: <SpringBootRestControllers /> },
    { label: "HTTP Requests", component: <SpringBootRequests /> },
    { label: "Validation", component: <SpringBootValidation /> },
    { label: "Service Layer", component: <SpringBootServiceLayer /> },
    { label: "JPA Repositories", component: <SpringBootJpaRepo /> },
    { label: "Relationships", component: <SpringBootRelationships /> },
    { label: "Pagination", component: <SpringBootPagination /> },
    { label: "DTO", component: <SpringBootDTO /> },
    { label: "Security", component: <SpringBootSecurity /> },
    { label: "JWT", component: <SpringBootJWT /> },
    { label: "Roles", component: <SpringBootRoles /> },
    { label: "Error Handling", component: <SpringBootGlobalError /> },
    { label: "Testing", component: <SpringBootTesting /> },
    { label: "Swagger", component: <SpringBootSwagger /> },
    { label: "Deployment", component: <SpringBootDeployment /> },
];

function SpringBootDashboardLinks() {
    const [selectedTab, setSelectedTab] = useState(0);
    const [search, setSearch] = useState("");
    const [darkMode, setDarkMode] = useState(false);

    const filteredTabs = tabs.filter(tab =>
        typeof tab.label === "string" && tab.label.toLowerCase().includes(search.toLowerCase())
    );

    const bgColor = darkMode ? "#1f1f1f" : "#f4f4f4";
    const textColor = darkMode ? "#f4f4f4" : "#1f1f1f";
    const activeColor = darkMode ? "#4caf50" : "#2e8b57";

    return (
        <div style={{ display: "flex", height: "100vh", fontFamily: "Segoe UI", flexDirection: "row" }}>
            <div
                style={{
                    width: "250px",
                    background: bgColor,
                    padding: "10px",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <input
                    type="text"
                    placeholder="Search topics..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                        padding: "8px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc"
                    }}
                />
                <label style={{ color: textColor, marginBottom: "10px" }}>
                    <input
                        type="checkbox"
                        checked={darkMode}
                        onChange={() => setDarkMode(!darkMode)}
                        style={{ marginRight: "8px" }}
                    />
                    Dark Mode
                </label>
                {filteredTabs.map((tab, index) => (
                    <div
                        key={index}
                        onClick={() => setSelectedTab(tabs.indexOf(tab))}
                        style={{
                            padding: "12px",
                            marginBottom: "4px",
                            cursor: "pointer",
                            background: tabs.indexOf(tab) === selectedTab ? activeColor : "transparent",
                            color: tabs.indexOf(tab) === selectedTab ? "#fff" : textColor,
                            borderRadius: "6px",
                            fontWeight: tabs.indexOf(tab) === selectedTab ? "bold" : "normal"
                        }}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div
                style={{
                    flex: 1,
                    padding: "20px",
                    overflowY: "auto",
                    background: darkMode ? "#121212" : "#fff",
                    color: textColor
                }}
            >
                {tabs[selectedTab]?.component || <p>No topic selected.</p>}
            </div>
        </div>
    );
}

export default SpringBootDashboardLinks;
